import { dataViewFormatter } from '@app/widgets/helpers/widgets';
import { EChartsOption, XAXisComponentOption, YAXisComponentOption } from 'echarts';
import moment from 'moment';

const BasicBarChartColourPalette = ['#6AB6B0', '#2A5FA5', '#52844B'];

const BasicBarChartXAxisTemplate: XAXisComponentOption = {
  type: 'category',
  tooltip: {
    show: true,
  },
  axisLine: {
    show: true,
    lineStyle: {
      color: '#999',
    },
  },
  axisPointer: {
    type: 'shadow',
  },
  boundaryGap: false,
  splitLine: { show: false },
  axisTick: { show: true },
  axisLabel: {
    rotate: 0,
  },
  data: [],
};

const BasicBarChartYAxisTemplate: YAXisComponentOption = {
  type: 'value',
  name: 'PLACEHOLDER',
  position: 'left',
  offset: 0,
  alignTicks: true,
  axisLine: {
    show: true,
    lineStyle: {
      color: BasicBarChartColourPalette[0],
    },
  },
};

const BasicBarChartEchartConfigTemplate: EChartsOption = {
  color: BasicBarChartColourPalette,
  legend: {},
  tooltip: {
    confine: true,
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985',
      },
    },
    textStyle: {
      color: '#fff',
    },
  },
  toolbox: {
    top: '10%',
    show: true,
    feature: {
      mark: { show: true },
      dataView: {
        show: true,
        readOnly: true,
        optionToContent: (option: any): string | HTMLElement => dataViewFormatter(option as EChartsOption),
      },
      restore: { show: true },
      saveAsImage: { show: true },
    },
  },
  grid: {
    top: '25%',
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    ...BasicBarChartXAxisTemplate,
  },
  yAxis: [],
  series: [],
};

export {
  BasicBarChartEchartConfigTemplate,
  BasicBarChartXAxisTemplate,
  BasicBarChartYAxisTemplate,
  BasicBarChartColourPalette,
};
